/** The one devtools line the YogiQL route emits when it steps aside or refuses. */
export function warnYogiQLFallback(reason: string): void {
  // eslint-disable-next-line no-console -- the one YogiQL-route warning PROD-5922 asks for; follow-up: PROD-6248 deletes the legacy routes and every fallback with them
  console.warn(`[charts-v2] YogiQL chart route: ${reason}`)
}

export const errorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : String(error)
